export default __webpack_public_path__ + "static/media/star-grey.62fa56ed.svg";